export interface CustomExtensionPoint {
    id?: string; // internal use
    index?: number; // internal use
    command: CustomCommand;
    name?: string;
    icon?: string;
    tooltip?: string;
    RaiseChangeCall?: boolean | "true" | "false" | "only";
    filter?: "NoShortNumber";
    AnswerOnClick?: boolean;
    correlatorData?: string;
    hexCorrelatorData?: string;
    responseType?: "markdown" | "json" | "adaptiveCard";
    displayJsonField?: string;
    firstNameJsonField?: string;
    lastNameJsonField?: string;
    companyJsonField?: string;
    adaptiveCardTemplate?: string;
    adaptiveCardTemplateJsonField?: string;
    adaptiveCardContentJsonField?: string;
    alsoForTeams?: boolean;
    popout?: boolean; // only used by 'on-main-window-actions' extension
    configUrl?: string;
    iconPath?: string; // internal use
    fileContent?: string; // internal use
    extensionType: CustomExtensionType;
}

export interface CustomCommand {
    commandType?: "rest" | "rest2" | "rainbowBot" | "file";
    url?: string;
    params?: string;
    method?: string;
    header?: any;
    bodyParameters?: Map<string, string>;
    remoteRpcJid?: string;
    appId?: string;
    directUrl?: boolean;
}

export interface CommandResult {
    type: "url" | "text" | "md" | "json" | "blob";
    data: any;
    name?: string;
}

export interface ExecutionResult {
    commandResult: CommandResult;
    firstName?: string;
    lastName?: string;
    companyName?: string;
    customExtensionId: string;
}

export enum CustomExtensionType {
    OUTGOING_PBX_CALL_ACTION = "onOutgoingPbxCallActions",
    INCOMING_PBX_CALL_ACTION = "onIncomingPbxCallActions",
    ANSWERING_INCOMING_PBX_CALL_ACTION = "onAnsweringIncomingPbxCallActions",
    RELEASING_INCOMING_PBX_CALL_ACTION = "onReleasingIncomingPbxCallActions",
    INCOMING_PBX_CALL_BUTTON_ACTION = "onIncomingPbxCallButtonActions",
    CONTACT_LIST_ACTION = "onContactListActions",
    CONTACT_DETAIL_ACTION = "onContactDetailActions",
    CALL_LOG_LIST_ACTION = "onCallLogListActions",
    COMMUNICATION_CARD_ACTION = "onCommunicationCardActions",
    BUBBLE_ACTION = "onBubbleActions",
    BUBBLE_CONFERENCE_ACTION = "onBubbleConferenceActions",
    INCOMING_PBX_CALL_DISPLAY_ACTION = "onIncomingPbxCallDisplayActions",
    CONTACT_CARD_DISPLAY_ACTION = "onContactCardDisplayActions",
    MAIN_WINDOW_ACTION = "onMainWindowActions",
    MAIN_DISPLAY_ACTION = "onMainDisplayActions",
    MAKECALL_INSERT_CORRELATOR_ACTION = "onMakecallInsertCorrelatorActions",
    MAIN_WIDGET_DISPLAY_ACTION = "onMainWidgetDisplayActions"
}
